import {useMemo} from 'react';

import {usePart} from '../../state/views/hooks';
import type * as WorkspaceSettingsTypes from '../../state/views/workspaceSettings/types';
import {type OrganizedSettings} from '../PanelBank/types';
import {useCascadingPointAggregationMethod} from '../WorkspaceDrawer/Settings/runLinePlots/utils/getCascadingPointAggregation';
/**
 * When we create a report from a workspace page, we want to copy the existing workspace settings over
 * to the new report. We're currently restructuring settings in workspaces, so this is a temporary
 * solution until reports is fully migrated over. Workspaces read from `workspaceSettings` and
 * reports will continue to read from `panelSettings` for now.
 */
export const useWorkspaceSettingsForReportCreation = (
  workspaceSettingsRef: WorkspaceSettingsTypes.Ref
): OrganizedSettings => {
  const workspaceSettings = usePart(workspaceSettingsRef);

  // We need to get the default poin vis method passed into reports
  const {pointVisualizationMethod} = useCascadingPointAggregationMethod(
    workspaceSettings.linePlot
  );

  return useMemo(
    () => ({
      linePlot: {
        ...workspaceSettings.linePlot,
        pointVisualizationMethod,
      },
    }),
    [workspaceSettings.linePlot, pointVisualizationMethod]
  );
};
